import Vue from 'vue'
import App from './App'
import router from './router'
import '@vant/touch-emulator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'

import * as echarts from "echarts";

import store from './store'//引入Vuex

import PageTop from './components/PageTop'
import PageNav from './components/PageNav'
import PageMe from './components/PageMe'
import PageFooter from './components/PageFooter'
import Share from './components/share'
import TransitionLoading from './components/Loading'

import Site from './assets/js/site.js'

import md5 from 'js-md5'

// import 'vant/lib/icon/local.css'

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import APlayer from '@moefe/vue-aplayer';

import Carousel3d from 'vue-carousel-3d';


// 按需引入 element
// import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// Vue.use(ElementUI);

// 思源黑体
import '../static/fonts/siyuan/icon.css';


import {
  DatePicker,
  TimeSelect,
  TimePicker,
  // Popover,
  Select,
  Option,
  Input,Upload
  
}from 'element-ui';
Vue.use(DatePicker)
   .use(TimeSelect)
   .use(TimePicker)
  //  .use(Popover)
   .use(Select)
   .use(Option).use(Input).use(Upload);

Vue.use(Carousel3d);

import {
  Button,
  Icon,
  Cell, CellGroup,
  Calendar,
  Card,
  Tag,
  Checkbox, CheckboxGroup,
  Radio, RadioGroup,
  Image,
  Lazyload,
  Swipe, SwipeItem,
  NavBar,
  Sticky,
  Grid, GridItem,
  Stepper,
  SubmitBar,
  Dialog,
  Popup,
  Form,
  DropdownMenu, DropdownItem,
  Field,
  ActionSheet,
  List,
  Toast,
  Collapse, CollapseItem,
  Tab, Tabs,
  Switch,
  Rate,
  Uploader,
  Area,
  Picker,
  Loading,
  DatetimePicker,
  Badge,
  Progress,
  CountDown,
  Pagination,
  Circle,
  Search,
  ImagePreview,
  Overlay,
  Popover,
  Row, Col,Steps,Step
} from 'vant'

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Switch)
  .use(Uploader)
  .use(Rate)
  .use(Picker)
  .use(Loading)
  .use(Area)
  .use(DatetimePicker)
  .use(Badge)
  .use(Progress)
  .use(VideoPlayer)
  .use(CountDown)
  .use(Pagination)
  .use(Circle)
  .use(Search)
  .use(ImagePreview)
  .use(Overlay)
  .use(Popover).use(Col).use(Row).use(Steps).use(Step)
  ;

Vue.use(Site);

Vue.use(VueAxios, axios);

Vue.use(PageTop)
   .use(PageNav)
   .use(PageMe)
   .use(PageFooter)
   .use(Share)
   .use(TransitionLoading);

Vue.use(APlayer, {
  defaultCover: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop/static/img/share_logo.png',
  productionTip: true,
});
/* https://aplayer.netlify.app/docs/guide/#%E4%BD%BF%E7%94%A8-npm 官方文档api */

//======= 注册自定义组件
Vue.component('PageTop', PageTop);
Vue.component('PageNav', PageNav);
Vue.component('PageMe', PageMe);
Vue.component('PageFooter', PageFooter);
Vue.component('Share', Share);
Vue.component('TransitionLoading', TransitionLoading);


Vue.prototype.qs = qs;

Vue.prototype.$echarts = echarts;

Vue.prototype.$md5 = md5;

//======= 路由守卫
router.beforeEach((to, from, next) => {

  //分享信息
  let metaList = document.getElementsByTagName('meta');
  for (var i = 0; i < metaList.length; i++) {
    if (metaList[i].getAttribute("name") == "shareImg") {
      metaList[i].content = "https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop/static/img/share_logo.png";
    }
    if (metaList[i].getAttribute("name") == "shareTitle") {
      metaList[i].content = document.title;
    }
    if (metaList[i].getAttribute("name") == "shareDesc") {
      metaList[i].content = '捷安特GRA微学平台';//document.title;
    }
    if (metaList[i].getAttribute("name") == "shareLink") {
      let tmpMeta = metaList[i];
      setTimeout(function(){
        tmpMeta.content = location.href;
      }, 100);
    }
  }

  //路由发生变化修改页面title
  if (to.meta.title) {
    if (to.path === '/') {
      document.title = 'GRA';
    } else {
      document.title = to.meta.title + ' - GRA';
    }
  }

  //获取到已登录的用户信息
  let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));

  if (loginuser_data && loginuser_data.sessionkey) {
    store.commit('updateLoginUser', loginuser_data);
  } else {
    //判断当前页是否需要登录
    if (to.meta.requireLogin) {
      //console.log(location.href);
      router.replace({ path: '/login', query: { redirect: location.href } });
      //router.replace({ path: '/login', query: { redirect: to.fullPath }});
      //router.push({ path: '/login', query: { redirect: to.fullPath }});
    }
  }
  next();
});

Vue.config.productionTip = false;

const _Vue = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
}).$mount("#app");

export default _Vue;


// WEBPACK FOOTER //
// ./src/main.js